/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as TimelineRouteImport } from './routes/timeline';
import { Route as SettingsRouteImport } from './routes/settings';
import { Route as RollupRouteImport } from './routes/rollup';
import { Route as LogRouteImport } from './routes/log';
import { Route as IndexRouteImport } from './routes/index';
import { Route as TrendsKindRouteImport } from './routes/trends.$kind';
import { Route as HelpShortcutsRouteImport } from './routes/help.shortcuts';

const TimelineRoute = TimelineRouteImport.update({
  id: '/timeline',
  path: '/timeline',
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any);
const RollupRoute = RollupRouteImport.update({
  id: '/rollup',
  path: '/rollup',
  getParentRoute: () => rootRouteImport,
} as any);
const LogRoute = LogRouteImport.update({
  id: '/log',
  path: '/log',
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const TrendsKindRoute = TrendsKindRouteImport.update({
  id: '/trends/$kind',
  path: '/trends/$kind',
  getParentRoute: () => rootRouteImport,
} as any);
const HelpShortcutsRoute = HelpShortcutsRouteImport.update({
  id: '/help/shortcuts',
  path: '/help/shortcuts',
  getParentRoute: () => rootRouteImport,
} as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/log': typeof LogRoute;
  '/rollup': typeof RollupRoute;
  '/settings': typeof SettingsRoute;
  '/timeline': typeof TimelineRoute;
  '/help/shortcuts': typeof HelpShortcutsRoute;
  '/trends/$kind': typeof TrendsKindRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/log': typeof LogRoute;
  '/rollup': typeof RollupRoute;
  '/settings': typeof SettingsRoute;
  '/timeline': typeof TimelineRoute;
  '/help/shortcuts': typeof HelpShortcutsRoute;
  '/trends/$kind': typeof TrendsKindRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/log': typeof LogRoute;
  '/rollup': typeof RollupRoute;
  '/settings': typeof SettingsRoute;
  '/timeline': typeof TimelineRoute;
  '/help/shortcuts': typeof HelpShortcutsRoute;
  '/trends/$kind': typeof TrendsKindRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/log'
    | '/rollup'
    | '/settings'
    | '/timeline'
    | '/help/shortcuts'
    | '/trends/$kind';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/log'
    | '/rollup'
    | '/settings'
    | '/timeline'
    | '/help/shortcuts'
    | '/trends/$kind';
  id:
    | '__root__'
    | '/'
    | '/log'
    | '/rollup'
    | '/settings'
    | '/timeline'
    | '/help/shortcuts'
    | '/trends/$kind';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  LogRoute: typeof LogRoute;
  RollupRoute: typeof RollupRoute;
  SettingsRoute: typeof SettingsRoute;
  TimelineRoute: typeof TimelineRoute;
  HelpShortcutsRoute: typeof HelpShortcutsRoute;
  TrendsKindRoute: typeof TrendsKindRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/timeline': {
      id: '/timeline';
      path: '/timeline';
      fullPath: '/timeline';
      preLoaderRoute: typeof TimelineRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/settings': {
      id: '/settings';
      path: '/settings';
      fullPath: '/settings';
      preLoaderRoute: typeof SettingsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/rollup': {
      id: '/rollup';
      path: '/rollup';
      fullPath: '/rollup';
      preLoaderRoute: typeof RollupRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/log': {
      id: '/log';
      path: '/log';
      fullPath: '/log';
      preLoaderRoute: typeof LogRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/trends/$kind': {
      id: '/trends/$kind';
      path: '/trends/$kind';
      fullPath: '/trends/$kind';
      preLoaderRoute: typeof TrendsKindRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/help/shortcuts': {
      id: '/help/shortcuts';
      path: '/help/shortcuts';
      fullPath: '/help/shortcuts';
      preLoaderRoute: typeof HelpShortcutsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LogRoute: LogRoute,
  RollupRoute: RollupRoute,
  SettingsRoute: SettingsRoute,
  TimelineRoute: TimelineRoute,
  HelpShortcutsRoute: HelpShortcutsRoute,
  TrendsKindRoute: TrendsKindRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
